import { PrimaryFocus } from '@/domain/primaryFocus/constant'
export const MIDFEED_PRIMARY_FOCUS_DEFAULT_BOOST = 30
export const EATING_DISORDER_MIDFEED_BOOST = 401
export const BEHAVIORAL_ADDICTION_MIDFEED_BOOST = 401

export const PRIMARY_FOCUS_MIDFEED_BOOST_DEFAULT_MAP = {
  [PrimaryFocus.SUBSTANCE_USE]: MIDFEED_PRIMARY_FOCUS_DEFAULT_BOOST,
  [PrimaryFocus.MENTAL_HEALTH]: MIDFEED_PRIMARY_FOCUS_DEFAULT_BOOST,
  [PrimaryFocus.SUBSTANCE_USE_AND_MENTAL_HEALTH]:
    MIDFEED_PRIMARY_FOCUS_DEFAULT_BOOST,
  [PrimaryFocus.EATING_DISORDERS]: EATING_DISORDER_MIDFEED_BOOST,
  [PrimaryFocus.BEHAVIORAL_ADDITION]: BEHAVIORAL_ADDICTION_MIDFEED_BOOST,
  [PrimaryFocus.WELLNESS]: MIDFEED_PRIMARY_FOCUS_DEFAULT_BOOST,
  [PrimaryFocus.AUTISM]: MIDFEED_PRIMARY_FOCUS_DEFAULT_BOOST
}
